import ReactGA from "react-ga4";
import React, { useEffect, useMemo, useState } from "react";
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import MapSection from './components/MapSection';
import SignupForm from './components/SignupForm';
import SlotCounter from "./components/SlotCounter";
import { motion } from "framer-motion";
import { ClipboardDocumentCheckIcon, UsersIcon } from '@heroicons/react/24/outline';

const galleryImages = [
  { original: process.env.PUBLIC_URL + "/images/86dc77b9-d855-4663-a306-83bfdb506ad8.JPG", thumbnail: process.env.PUBLIC_URL + "/images/86dc77b9-d855-4663-a306-83bfdb506ad8.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5344.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5344.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5345.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5345.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5346.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5346.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5347.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5347.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5348.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5348.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_53700.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_53700.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5514.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5514.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5741.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5741.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5743.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5743.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5786.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5786.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5797.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5797.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5798.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5798.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5800.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5800.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5804.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5804.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5981.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5981.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5983.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5983.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5984.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5984.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5986.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5986.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_5988.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_5988.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6001.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6001.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6002.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6002.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6003.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6003.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6004.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6004.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6085.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6085.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6088.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6088.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6089.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6089.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6091.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6091.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6093.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6093.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6094.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6094.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6095.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6095.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6096.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6096.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6098.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6098.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6100.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6100.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6151.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6151.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6158.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6158.JPG" },
  { original: process.env.PUBLIC_URL + "/images/IMG_6159.JPG", thumbnail: process.env.PUBLIC_URL + "/images/IMG_6159.JPG" },

  // ===== DODANE NOWE ZDJĘCIA =====
  { original: process.env.PUBLIC_URL + "/images/IMG_20250808_200958.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250808_200958.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250808_163542.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250808_163542.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250808_131425.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250808_131425.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250808_131358.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250808_131358.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250808_110119.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250808_110119.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_231118.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_231118.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_230334.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_230334.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_213941.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_213941.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_213908.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_213908.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_204014.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_204014.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_203205.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_203205.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_203155.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_203155.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_203011.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_203011.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_202941.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_202941.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_193435_1.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_193435_1.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_191748.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_191748.jpg" },
  { original: process.env.PUBLIC_URL + "/images/IMG_20250807_191521.jpg", thumbnail: process.env.PUBLIC_URL + "/images/IMG_20250807_191521.jpg" }
];


// ====== DANE TERMINARZA (na start statycznie; potem podmienimy na źródło z Google Sheets) ======
const EVENTS = [
  {
    id: "EV-250829-A",
    title: "Obóz survivalowy – Dorosły + Dziecko",
    type: "rodzinny",
    start: "2025-09-26",
    end: "2025-09-28",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł + 250 zł/dziecko",
    badge: "Najbliższy termin"
  },
  {
    id: "EV-250912-B",
    title: "Obóz survivalowy – Tylko dorośli",
    type: "dorosli",
    start: "2025-09-26",
    end: "2025-09-28",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł",
    badge: "Najbliższy termin"
  },
  {
    id: "EV-250926-C",
    title: "Obóz survivalowy – Dorosły + Dziecko",
    type: "rodzinny",
    start: "2025-10-03",
    end: "2025-10-04",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł + 250 zł/dziecko",
    badge: "Jesienny"
  },
  {
    id: "EV-251010-D",
    title: "Obóz survivalowy – Tylko dorośli",
    type: "dorosli",
    start: "2025-10-03",
    end: "2025-10-04",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł",
    badge: "Jesienny"
  },
  {
    id: "EV-251010-D",
    title: "Obóz survivalowy – Dorosły + Dziecko",
    type: "dorosli",
    start: "2025-10-10",
    end: "2025-10-12",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł",
    badge: "Jesienny"
  },
  {
    id: "EV-251010-D",
    title: "Obóz survivalowy – Tylko dorośli",
    type: "dorosli",
    start: "2025-10-10",
    end: "2025-10-12",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł",
    badge: "Jesienny"
  },
  {
    id: "EV-251010-D",
    title: "Obóz survivalowy – Dorosły + Dziecko",
    type: "dorosli",
    start: "2025-10-17",
    end: "2025-10-19",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł",
    badge: "Jesienny"
  },
  {
    id: "EV-251010-D",
    title: "Obóz survivalowy – Tylko dorośli",
    type: "dorosli",
    start: "2025-10-17",
    end: "2025-10-19",
    location: "Góry Świętokrzyskie (baza PrzetrwajTo)",
    spots: 12,
    confirmed: 0,
    price: "600 zł",
    badge: "Jesienny"
  }
];

// ====== POMOCE FORMATUJĄCE ======
function fmtRange(startISO, endISO) {
  const s = new Date(startISO);
  const e = new Date(endISO);
  const sameMonth = s.getMonth() === e.getMonth();
  const months = ["stycznia","lutego","marca","kwietnia","maja","czerwca","lipca","sierpnia","września","października","listopada","grudnia"];
  const d = (d)=> String(d).padStart(2,"0");
  if (sameMonth) {
    return `${d(s.getDate())}–${d(e.getDate())} ${months[s.getMonth()]} ${e.getFullYear()}`;
  }
  return `${d(s.getDate())} ${months[s.getMonth()]} – ${d(e.getDate())} ${months[e.getMonth()]} ${e.getFullYear()}`;
}
function spotsLeft(ev) {
  const left = Math.max(0, (ev.spots || 0) - (ev.confirmed || 0));
  return { left, percent: ev.spots ? Math.min(100, Math.round(((ev.spots - left)/ev.spots)*100)) : 0 };
}
function getNextEvent(now = new Date()) {
  const upcoming = EVENTS
    .map(e => ({...e, startDate: new Date(e.start)}))
    .filter(e => e.startDate >= new Date(now.toDateString()))
    .sort((a,b) => a.startDate - b.startDate);
  return upcoming[0] || null;
}
function monthsAhead(n=6) {
  const out = [];
  const base = new Date();
  base.setDate(1);
  for (let i=0;i<n;i++){
    const d = new Date(base.getFullYear(), base.getMonth()+i, 1);
    out.push({
      key: `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`,
      label: d.toLocaleDateString('pl-PL', { month: 'long', year: 'numeric' })
    });
  }
  return out;
}

function App() {
  useEffect(() => {
    ReactGA.initialize("G-H9S504ZG10");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const [current, setCurrent] = useState(0);
  const nextSlide = () => setCurrent((current + 1) % galleryImages.length);
  const prevSlide = () => setCurrent((current - 1 + galleryImages.length) % galleryImages.length);

  // ====== STAN TERMINARZA ======
  const [tab, setTab] = useState("all"); // all | rodzinny | dorosli
  const [monthKey, setMonthKey] = useState(""); // "" = wszystkie
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(()=> setNow(new Date()), 1000);
    return ()=> clearInterval(t);
  }, []);
  const nextEv = useMemo(()=> getNextEvent(now), [now]);
  const countdown = useMemo(()=>{
    if (!nextEv) return null;
    const target = new Date(nextEv.start + "T08:00:00");
    const diff = target - now;
    if (diff <= 0) return { d:0,h:0,m:0,s:0 };
    const d = Math.floor(diff / (1000*60*60*24));
    const h = Math.floor((diff / (1000*60*60)) % 24);
    const m = Math.floor((diff / (1000*60)) % 60);
    const s = Math.floor((diff / 1000) % 60);
    return { d,h,m,s };
  }, [now, nextEv]);

  const monthsOptions = monthsAhead(7);
  const filtered = useMemo(()=>{
    return EVENTS.filter(e=>{
      if (tab !== "all" && e.type !== tab) return false;
      if (monthKey) {
        const k = `${new Date(e.start).getFullYear()}-${String(new Date(e.start).getMonth()+1).padStart(2,'0')}`;
        if (k !== monthKey) return false;
      }
      return true;
    }).sort((a,b) => new Date(a.start) - new Date(b.start));
  }, [tab, monthKey]);
  // === MODALE RODO/PRIVACY ===
const [showRodoModal, setShowRodoModal] = useState(false);
const [showPrivacyModal, setShowPrivacyModal] = useState(false);

useEffect(() => {
  const openRodo = () => setShowRodoModal(true);
  const openPrivacy = () => setShowPrivacyModal(true);
  window.addEventListener('open-rodo-modal', openRodo);
  window.addEventListener('open-privacy-modal', openPrivacy);
  return () => {
    window.removeEventListener('open-rodo-modal', openRodo);
    window.removeEventListener('open-privacy-modal', openPrivacy);
  };
}, []);


  return (
    <div className="text-white scroll-smooth">
      {/* NAVBAR */}
      <header className="fixed top-0 left-0 w-full z-50 bg-black bg-opacity-60 backdrop-blur-md border-b border-[#88cc00]/30 shadow-lg">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="/logo-wilk-wzgorze.png"
              alt="Logo Przetrwaj To"
              className="h-12 md:h-20 drop-shadow-lg select-none"
            />
            <span className="text-xl md:text-2xl font-extrabold text-[#88cc00] tracking-widest select-none hidden sm:inline">
              PrzetrwajTo
            </span>
          </div>

          {/* Nawigacja – dodano „Terminarz” */}
          <nav className="space-x-4 md:space-x-6 text-sm md:text-base font-medium text-white">
            {["Oferta", "Program", "Terminarz", "Galeria", "Zgłoszenia", "Formularz kontaktowy", "Kontakt"].map((label, index) => {
              const id = [
                "#oferta",
                "#program",
                "#terminarz",
                "#galeria",
                "#formularz",
                "#kontakt-form",
                "#kontakt",
              ][index];
              return (
                <a
                  key={id}
                  href={id}
                  className="relative group transition-all duration-200 hover:text-[#88cc00]"
                >
                  {label}
                  <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-[#88cc00] group-hover:w-full transition-all duration-300 ease-in-out"></span>
                </a>
              );
            })}
          </nav>
        </div>
      </header>

      {/* HERO */}
      <div className="relative min-h-screen flex items-center justify-center px-4 pt-24 overflow-hidden bg-black">
        <img
          src="/images/IMG_5804.JPG"
          alt="Survival background"
          className="absolute inset-0 w-full h-full object-cover opacity-100 brightness-100 contrast-125 transition duration-1000"
        />
        <div className="absolute inset-0 bg-black animate-darkFade pointer-events-none" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/asfalt-dark.png')] opacity-20 pointer-events-none" />
        <div className="absolute inset-0 bg-gradient-to-br from-transparent via-black/40 to-transparent animate-sweep pointer-events-none" />
        <div className="relative z-10 max-w-3xl text-center px-6 py-12 select-none">
          <h1 className="text-5xl md:text-6xl font-extrabold text-[#88cc00] mb-6 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)] animate-crt tracking-widest">
            PrzetrwajTo  Obozy Survivalowe
          </h1>
          <p className="text-xl md:text-2xl text-white leading-snug mb-8 drop-shadow-[0_2px_4px_rgba(0,0,0,0.7)] animate-flicker">
            Zanurz się w przygodzie. Sam lub z dzieckiem. Przeżyj trzydniowy obóz, który zostanie w Twojej pamięci na zawsze.
          </p>
          <a
            href="#formularz"
            className="inline-block bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold px-8 py-4 rounded-full text-xl shadow-lg transition-transform transform hover:scale-105 animate-pulse"
          >
            🏕️ Zapisz się na obóz
          </a>
        </div>
      </div>

      {/* SEKCJA OFERTY */}
      <section
        id="oferta"
        className="relative py-28 px-6 bg-[#1f1f1f] text-white overflow-hidden"
      >
        <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
          <div className="absolute top-[-100px] left-[10%] w-[200px] h-[200px] animate-dym1 opacity-20">
            <div className="w-full h-full bg-gradient-to-t from-gray-400 via-gray-300 to-transparent rounded-full blur-3xl"></div>
          </div>
          <div className="absolute bottom-[-50px] right-[15%] w-[250px] h-[250px] animate-dym2 opacity-15">
            <div className="w-full h-full bg-gradient-to-t from-gray-400 via-gray-200 to-transparent rounded-full blur-3xl"></div>
          </div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto text-center mb-20">
          <h2 className="text-7xl font-extrabold mb-4 text-[#88cc00] drop-shadow-lg">
            Nasza Oferta
          </h2>
          <p className="text-2xl text-gray-200">
            Wybierz wersję survivalu najlepiej dopasowaną do Ciebie.
          </p>
        </div>

        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* KARTA 1 */}
          <div className="bg-[#2c2c2c] rounded-3xl border border-[#88cc00] p-10 shadow-xl hover:scale-[1.02] hover:shadow-[#88cc00]/70 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-[#88cc00]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 3a1 1 0 00-1 1v.25a4.75 4.75 0 104.5 0V4a1 1 0 00-1-1h-2.5zM6.5 13a4.5 4.5 0 018.987.418l.5 5a2 2 0 01-1.99 2.082H7.003A2 2 0 015.013 18.42l.487-5A4.5 4.5 0 016.5 13z" />
              </svg>
              <h3 className="text-4xl font-bold">Dorosły + dziecko</h3>
            </div>
            <p className="text-gray-300 text-lg mb-6">
              Czas z dala od ekranów i hałasu miasta – wspólnie pokonacie wyzwania i zbudujecie wspomnienia. Do 2 dzieci pod opieką dorosłego.
            </p>
            <ul className="list-disc list-inside text-gray-300 text-lg space-y-2 mb-6">
              <li>2 noclegi w lesie</li>
              <li>Ognisko, woda, mapa, nocne przejście</li>
              <li>Warsztaty rodzinne i zadania zespołowe</li>
            </ul>
            <p className="font-bold text-2xl text-[#88cc00]">Cena: 600 zł + 250 zł/dziecko</p>
            <p className="text-base text-gray-400">Max 12 osób w grupie</p>
          </div>

          {/* KARTA 2 */}
          <div className="bg-[#2c2c2c] rounded-3xl border border-[#88cc00] p-10 shadow-xl hover:scale-[1.02] hover:shadow-[#88cc00]/70 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-[#88cc00]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4-6 4 4 4-6 4 8H4z" />
              </svg>
              <h3 className="text-4xl font-bold">Tylko dla dorosłych</h3>
            </div>
            <p className="text-gray-300 text-lg mb-6">
              Surowa wersja survivalu. 3 dni skupienia, treningu mentalnego i fizycznego. Naucz się reagować w trudnych warunkach.
            </p>
            <ul className="list-disc list-inside text-gray-300 text-lg space-y-2 mb-6">
              <li>2 noce w terenie</li>
              <li>Szkolenie z przetrwania i samoobrony</li>
              <li>Opcjonalna strzelnica w Starachowicach</li>
            </ul>
            <p className="font-bold text-2xl text-[#88cc00]">Cena: 600 zł</p>
            <p className="text-base text-gray-400">Max 12 osób w grupie</p>
          </div>
        </div>
      </section>

      {/* PROGRAM RODZINNY */}
      <section id="program" className="bg-[#0f1011] py-20 px-6">
        <div className="max-w-5xl mx-auto text-center mb-16">
          <h2 className="text-7xl font-extrabold text-[#88cc00] mb-4 drop-shadow-lg flex items-center justify-center gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-10 h-10">
              <path d="M12 2C12 2 6 7.5 6 11a6 6 0 0012 0c0-3.5-6-9-6-9z" />
              <path d="M12 15c-1.1 0-2-.9-2-2 0-.7.5-1.5 1.5-2 .8.6 1.5 1.2 1.5 2 0 1.1-.9 2-1 2z" />
            </svg>
            Program Rodzinny
          </h2>
          <p className="text-2xl text-gray-200">
            Wersja rodzinna: Dorosły + dziecko. Trzy dni wspólnych przygód i zadań survivalowych.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-7xl mx-auto text-left">
          {[
            {
              icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-6 h-6"><path d="M12 2C12 2 6 7.5 6 11a6 6 0 0012 0c0-3.5-6-9-6-9z" /></svg>,
              title: "Dzień 1 : Wspólny start",
              subtitle: "Początek przygody – budowanie więzi i pierwsze doświadczenia terenowe.",
              items: [
                "Przyjazd i rozpakowanie",
                "Wprowadzenie do survivalu",
                "Pakowanie plecaka pod presją",
                "Budowa obozowiska i wspólne ognisko"
              ]
            },
            {
              icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-6 h-6"><path d="M12 2L2 22h20L12 2zm0 3.84L18.93 20H5.07L12 5.84z" /></svg>,
              title: "Dzień 2 : Wspólne wyzwania",
              subtitle: "Rodzinne zadania w terenie – mapa, ogień, woda i wspólny posiłek.",
              items: [
                "Terenowa wyprawa z mapą i kompasem",
                "Nauka rozpalania ognia i uzdatniania wody",
                "Rodzinny obiad w terenie",
                "Nocna misja z niespodzianką"
              ]
            },
            {
              icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-6 h-6"><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm1 15l-5-5 1.41-1.41L13 14.17l6.59-6.59L21 9z" /></svg>,
              title: "Dzień 3 : Zgrani w terenie",
              subtitle: "Zakończenie – pamiątki, wspomnienia i powrót do domu.",
              items: [
                "Podsumowanie i wręczenie pamiątek",
                "Pożegnanie z lasem"
              ]
            }
          ].map((day, index) => (
            <div
              key={index}
              className="bg-[#1c1c1c] p-10 rounded-3xl border border-[#88cc00] shadow-xl hover:scale-[1.02] hover:shadow-[#88cc00]/70 transition-all duration-500"
            >
              <h3 className="text-2xl text-white font-bold mb-3 flex items-center gap-2">
                {day.icon}
                {day.title}
              </h3>
              <div className="bg-[#2a2a2a] text-lime-200 text-[16px] italic px-4 py-3 mb-6 rounded-lg shadow-inner leading-snug">
                {day.subtitle}
              </div>
              <ul className="list-disc list-inside text-gray-200 text-[17px] leading-relaxed space-y-2">
                {day.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <a
            href="/Program%20szczeg%C3%B3%C5%82owy1.pdf"
            download
            className="inline-block bg-[#4c6b2d] hover:bg-[#5a7d35] text-white text-lg font-semibold py-3 px-6 rounded-full shadow-lg transition"
          >
            📄 Pobierz szczegółowy program PDF (rodzinny)
          </a>
        </div>
      </section>

      {/* PROGRAM DLA DOROSŁYCH */}
      <section id="program-dorosli" className="bg-[#0f1011] py-20 px-6">
        <div className="max-w-5xl mx-auto text-center mb-16">
          <h2 className="text-7xl font-extrabold text-[#88cc00] mb-4 drop-shadow-lg flex items-center justify-center gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-10 h-10">
              <path d="M12 2C12 2 6 7.5 6 11a6 6 0 0012 0c0-3.5-6-9-6-9z" />
              <path d="M12 15c-1.1 0-2-.9-2-2 0-.7.5-1.5 1.5-2 .8.6 1.5 1.2 1.5 2 0 1.1-.9 2-1 2z" />
            </svg>
            Program dla Dorosłych
          </h2>
          <p className="text-2xl text-gray-200">
            Wersja dla dorosłych. Intensywny program dla tych, którzy chcą sprawdzić swoje granice.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-7xl mx-auto text-left">
          {[
            {
              icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-6 h-6"><path d="M12 2C12 2 6 7.5 6 11a6 6 0 0012 0c0-3.5-6-9-6-9z" /></svg>,
              title: "Dzień 1 : Start w nieznane",
              subtitle: "Start z przytupem – sprzęt, stres i pierwsza noc w dziczy.",
              items: [
                "Przyjazd, sprawdzenie sprzętu",
                "Wprowadzenie do survivalu",
                "Pakowanie pod presją i pierwszy nocleg w dziczy"
              ]
            },
            {
              icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-6 h-6"><path d="M12 2L2 22h20L12 2zm0 3.84L18.93 20H5.07L12 5.84z" /></svg>,
              title: "Dzień 2 : Umiejętność to siła",
              subtitle: "Orientacja, przetrwanie i współpraca – dzień wyzwań.",
              items: [
                "Orientacja w terenie, ogień, woda, jedzenie",
                "Zadania indywidualne i zespołowe",
                "Nocny marsz z noktowizją"
              ]
            },
            {
              icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#88cc00" viewBox="0 0 24 24" className="w-6 h-6"><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm1 15l-5-5 1.41-1.41L13 14.17l6.59-6.59L21 9z" /></svg>,
              title: "Dzień 3 : Powrót z tarczą",
              subtitle: "Zakończenie szkolenia i dodatkowa atrakcja dla chętnych.",
              items: [
                "Podsumowanie umiejętności",
                "Opcjonalny wyjazd na strzelnicę w Starachowicach"
              ]
            }
          ].map((day, index) => (
            <div
              key={index}
              className="bg-[#1c1c1c] p-10 rounded-3xl border border-[#88cc00] shadow-xl hover:scale-[1.02] hover:shadow-[#88cc00]/70 transition-all duration-500"
            >
              <h3 className="text-2xl text-white font-bold mb-3 flex items-center gap-2">
                {day.icon}
                {day.title}
              </h3>
              <div className="bg-[#2a2a2a] text-lime-200 text-[16px] italic px-4 py-3 mb-6 rounded-lg shadow-inner leading-snug">
                {day.subtitle}
              </div>
              <ul className="list-disc list-inside text-gray-200 text-[17px] leading-relaxed space-y-2">
                {day.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <a
            href="/Program%20szczeg%C3%B3%C5%82owy2.pdf"
            download
            className="inline-block bg-[#4c6b2d] hover:bg-[#5a7d35] text-white text-lg font-semibold py-3 px-6 rounded-full shadow-lg transition"
          >
            📄 Pobierz szczegółowy program PDF (dorośli)
          </a>
        </div>
      </section>

      {/* ====== TERMINARZ – NOWA SEKCJA ====== */}
      <section id="terminarz" className="relative py-24 px-6 bg-black">
        <div className="max-w-6xl mx-auto">
          {/* Pasek z odliczaniem */}
          {nextEv && countdown && (
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-10"
            >
              <div className="rounded-2xl border border-[#88cc00]/40 bg-gradient-to-r from-[#1a1f14] to-[#0e120b] p-6 md:p-8 shadow-[0_0_30px_rgba(136,204,0,0.15)]">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                  <div>
                    <div className="inline-flex items-center gap-2 mb-2">
                      <span className="px-3 py-1 rounded-full text-xs font-bold tracking-widest bg-[#88cc00]/20 text-[#b9ff3c] border border-[#88cc00]/30 uppercase">
                        Nadchodzące wydarzenie
                      </span>
                    </div>
                    <h3 className="text-2xl md:text-3xl font-extrabold text-white">
                      {nextEv.title}
                    </h3>
                    <p className="text-gray-300 mt-1">{fmtRange(nextEv.start, nextEv.end)} • {nextEv.location}</p>
                  </div>
                  <div className="grid grid-flow-col auto-cols-max gap-3 text-center">
                    {["d","h","m","s"].map((k)=>(
                      <div key={k} className="bg-[#1b1f16] rounded-xl px-4 py-3 border border-[#88cc00]/30 min-w-[70px]">
                        <div className="text-2xl md:text-3xl font-extrabold text-[#b9ff3c] tabular-nums">{String(countdown[k]).padStart(2,"0")}</div>
                        <div className="text-xs uppercase tracking-widest text-gray-400">{k==="d"?"dni":k==="h"?"godz":k==="m"?"min":"sek"}</div>
                      </div>
                    ))}
                  </div>
                  <div className="flex gap-3">
                    <a href="#formularz" className="inline-flex items-center justify-center rounded-xl px-5 py-3 bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold shadow">
                      Zapisz się
                    </a>
                    <a href={nextEv.type === "rodzinny" ? "#program" : "#program-dorosli"} className="inline-flex items-center justify-center rounded-xl px-5 py-3 bg-[#1b1f16] hover:bg-[#26301a] text-[#b9ff3c] border border-[#88cc00]/30 font-semibold">
                      Zobacz program
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          )}

          {/* Filtry */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
            <div className="inline-flex bg-[#111] rounded-xl p-1 border border-[#88cc00]/30">
              {[
                {key:"all", label:"Wszystkie"},
                {key:"rodzinny", label:"Rodzinny"},
                {key:"dorosli", label:"Dorośli"},
              ].map(t=>(
                <button
                  key={t.key}
                  onClick={()=> setTab(t.key)}
                  className={`px-4 py-2 rounded-lg text-sm font-semibold transition ${
                    tab===t.key ? "bg-[#4c6b2d] text-white" : "text-gray-300 hover:text-white"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <label className="text-sm text-gray-400">Miesiąc:</label>
              <select
                value={monthKey}
                onChange={(e)=> setMonthKey(e.target.value)}
                className="bg-[#111] border border-[#88cc00]/30 rounded-lg px-3 py-2 text-sm text-gray-200"
              >
                <option value="">Wszystkie</option>
                {monthsOptions.map(m=>(
                  <option key={m.key} value={m.key}>{m.label}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Karty wydarzeń */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {filtered.map(ev=>{
              const { left, percent } = spotsLeft(ev);
              const soldOut = left === 0;
              return (
                <motion.div
                  key={ev.id}
                  initial={{ opacity: 0, y: 8 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  className={`relative rounded-2xl border p-6 md:p-7 bg-[#121612] ${soldOut ? "border-red-600/40" : "border-[#88cc00]/40"} shadow-[0_0_30px_rgba(0,0,0,0.25)]`}
                >
                  {/* Badge */}
                  <div className="absolute top-4 right-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-bold tracking-widest uppercase border ${soldOut ? "bg-red-900/30 text-red-300 border-red-600/40" : "bg-[#88cc00]/20 text-[#b9ff3c] border-[#88cc00]/30"}`}>
                      {soldOut ? "Brak miejsc" : ev.badge}
                    </span>
                  </div>

                  <h3 className="text-2xl font-extrabold text-white pr-32">{ev.title}</h3>
                  <p className="text-gray-300 mt-1">{fmtRange(ev.start, ev.end)} • {ev.location}</p>
                  <p className="text-gray-400 mt-1">{ev.type === "rodzinny" ? "Wersja rodzinna" : "Wersja dla dorosłych"} • {ev.price}</p>

                  {/* Pasek zajętości miejsc */}
                  <div className="mt-5">
                    <div className="flex justify-between text-sm text-gray-400 mb-1">
                      <span>Zajętość miejsc</span>
                      <span>{ev.confirmed}/{ev.spots} (pozostało {left})</span>
                    </div>
                    <div className="w-full h-2 rounded-full bg-[#1b1f16] overflow-hidden border border-[#88cc00]/20">
                      <div
                        className={`h-full ${soldOut ? "bg-red-600" : "bg-[#88cc00]"}`}
                        style={{ width: `${percent}%` }}
                      />
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="mt-6 flex flex-wrap gap-3">
                    <a
                      href="#formularz"
                      className={`inline-flex items-center gap-2 rounded-xl px-5 py-3 font-semibold shadow ${soldOut ? "bg-gray-700 text-gray-300 cursor-not-allowed" : "bg-[#4c6b2d] hover:bg-[#5a7d35] text-white"}`}
                      onClick={(e)=> { if (soldOut) e.preventDefault(); }}
                    >
                      <UsersIcon className="w-5 h-5" />
                      {soldOut ? "Brak miejsc" : "Zapisz się"}
                    </a>
                    <a
                      href={ev.type === "rodzinny" ? "#program" : "#program-dorosli"}
                      className="inline-flex items-center gap-2 rounded-xl px-5 py-3 bg-[#1b1f16] hover:bg-[#26301a] text-[#b9ff3c] border border-[#88cc00]/30 font-semibold"
                    >
                      <ClipboardDocumentCheckIcon className="w-5 h-5" />
                      Zobacz program
                    </a>
                  </div>
                </motion.div>
              );
            })}
          </div>

          {/* Info gdy brak wyników po filtrach */}
          {filtered.length === 0 && (
            <div className="text-center text-gray-400 mt-8">
              Brak terminów dla wybranych filtrów. Zmień typ lub miesiąc.
            </div>
          )}
        </div>
      </section>

      {/* GALERIA */}
      <section id="galeria" className="relative py-20 px-6 bg-black text-white overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/asfalt-dark.png')] opacity-10 pointer-events-none"></div>

        <div className="max-w-5xl mx-auto text-center mb-12 relative z-10">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#88cc00] mb-4 tracking-wide drop-shadow-[0_2px_10px_rgba(136,204,0,0.6)] animate-flicker">
            Galeria
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto animate-fade-rise">
            Zobacz ujęcia z poprzednich obozów – survival, przygoda i wyzwania uchwycone w kadrach.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative z-10 animate-fade-rise-slow">
          <ImageGallery
            items={galleryImages}
            showPlayButton={false}
            showFullscreenButton={true}
            thumbnailPosition="bottom"
            slideDuration={1000}
            slideInterval={4000}
          />
        </div>
      </section>

      {/* FORMULARZ */}
      <section id="formularz" className="bg-white text-gray-800 py-16 px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Zapisz się na obóz</h2>
          <SlotCounter />
          <p className="text-lg text-gray-600">
            Wypełnij formularz zgłoszeniowy. Po jego wysłaniu otrzymasz e-mail z potwierdzeniem, a my skontaktujemy się z Tobą.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <SignupForm />
        </div>
      </section>

      {/* KONTAKT */}
<section id="kontakt-form" className="bg-white text-gray-800 py-16 px-6">
  <div className="max-w-3xl mx-auto text-center mb-12">
    <h2 className="text-4xl font-bold mb-4">Formularz kontaktowy</h2>
    <p className="text-lg text-gray-600">Masz pytanie? Napisz do nas – odpiszemy jak najszybciej.</p>
  </div>
  <form
    className="max-w-2xl mx-auto grid gap-6"
    onSubmit={(e) => {
      e.preventDefault();
      const form = e.target;

      const rodoOk = form.querySelector('#rodo_contact_checkbox')?.checked;
      const privacyOk = form.querySelector('#privacy_contact_checkbox')?.checked;
      if (!rodoOk || !privacyOk) {
        toast.error("Zaznacz wymagane zgody (RODO i Polityka prywatności).");
        return;
      }

      emailjs.sendForm(
        'service_nuhju2n',
        'template_qpikvgk',
        form,
        'UDBMcnzLOk_u8unmJ'
      ).then(() => {
        toast.success("✅ Wiadomość wysłana!");
        form.reset();
      }).catch((error) => {
        toast.error("❌ Błąd wysyłki: " + error.text);
      });
    }}
  >
    <input type="text" name="from_name" placeholder="Imię i nazwisko" className="p-3 border border-gray-300 rounded-lg w-full" required />
    <input type="email" name="from_email" placeholder="Adres e-mail" className="p-3 border border-gray-300 rounded-lg w-full" required />
    <input type="tel" name="phone" placeholder="Numer telefonu" className="p-3 border border-gray-300 rounded-lg w-full" />
    <textarea name="message" placeholder="Treść wiadomości" className="p-3 border border-gray-300 rounded-lg w-full" rows="4" />

    {/* ZGODY – obie wymagane */}
    <label className="flex items-start gap-3 text-sm text-gray-700">
      <input id="rodo_contact_checkbox" name="rodo_consent" type="checkbox" required className="mt-1 h-4 w-4" />
      <span>
        Oświadczam, że zapoznałem(-am) się z{" "}
        <button
          type="button"
          onClick={() => setShowRodoModal(true)}
          className="underline text-[#4c6b2d] hover:text-[#5a7d35]"
        >informacją RODO</button>{" "}
        i wyrażam zgodę na przetwarzanie moich danych w celu kontaktu.
      </span>
    </label>

    <label className="flex items-start gap-3 text-sm text-gray-700 -mt-2">
      <input id="privacy_contact_checkbox" name="privacy_consent" type="checkbox" required className="mt-1 h-4 w-4" />
      <span>
        Akceptuję{" "}
        <button
          type="button"
          onClick={() => setShowPrivacyModal(true)}
          className="underline text-[#4c6b2d] hover:text-[#5a7d35]"
        >Politykę prywatności</button>.
      </span>
    </label>

    <button type="submit" className="w-full bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold px-8 py-4 rounded-md text-lg shadow-md transition-colors duration-300">
      Wyślij wiadomość
    </button>
  </form>
</section>

      {/* MAPA */}
      <section id="mapa" className="bg-[#f7f6f3] pt-40 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <div className="inline-block mb-4">
            <span className="inline-block bg-[#4c6b2d] text-white text-sm tracking-widest font-semibold px-4 py-2 rounded-full shadow-md uppercase">
              lokalizacja
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1f2d16] tracking-wide drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]">
            Gdzie jesteśmy?
          </h2>
          <p className="mt-4 text-lg md:text-xl text-[#3a3a3a] font-medium leading-relaxed max-w-2xl mx-auto">
            Nasz obóz mieści się w sercu <span className="text-[#4c6b2d] font-semibold">Gór Świętokrzyskich</span>,
            otoczony lasami, czystą wodą i dziką naturą. Zobacz na mapie i znajdź naszą bazę!
          </p>
        </div>

        <div className="flex justify-center">
          <div className="relative z-10 w-full max-w-3xl h-[420px] rounded-xl overflow-hidden shadow-xl border-2 border-[#d5d2c5]">
            <MapSection />
          </div>
        </div>
      </section>
      {/* === MODAL: RODO === */}
{showRodoModal && (
  <div className="fixed inset-0 z-[100] flex items-center justify-center">
    <div className="absolute inset-0 bg-black/70" onClick={() => setShowRodoModal(false)} />
    <div className="relative bg-[#0f1011] text-gray-100 w-[95vw] max-w-3xl max-h-[85vh] rounded-2xl border border-[#88cc00]/30 shadow-2xl overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b border-[#88cc00]/20">
        <h3 className="text-xl font-bold text-[#b9ff3c]">Informacja RODO</h3>
        <button
          className="text-gray-300 hover:text-white text-2xl leading-none"
          onClick={() => setShowRodoModal(false)}
          aria-label="Zamknij"
        >×</button>
      </div>
      <div className="p-6 overflow-auto space-y-4">
        {/* === Wklej swoją pełną treść RODO poniżej === */}

        <p>
          Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO) informujemy, że:
        </p>
        <ol className="list-decimal list-inside space-y-2">
          <li>
            <strong>Administrator danych:</strong> Administratorem danych osobowych jest Stowarzyszenie Bonum Publicum, z siedzibą przy ul. 1 Maja 191, 25-646 Kielce.
          </li>
          <li>
            <strong>Cele przetwarzania:</strong> Dane przetwarzane będą w celu organizacji i realizacji obozu survivalowego „PrzetrwajTo”, zapewnienia bezpieczeństwa i opieki medycznej, kontaktu z rodzicami/opiekunami, prowadzenia dokumentacji organizacyjnej i księgowej oraz – w przypadku wyrażenia dodatkowej zgody – w celach promocyjnych (publikacja zdjęć/wizerunku).
          </li>
          <li>
            <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. a, c i f RODO.
          </li>
          <li>
            <strong>Odbiorcy danych:</strong> Dane mogą być udostępniane kadrze obozowej, służbom medycznym, a także podmiotom uprawnionym na podstawie przepisów prawa.
          </li>
          <li>
            <strong>Okres przechowywania:</strong> Dane będą przechowywane przez okres trwania obozu oraz wymagany przepisami prawa.
          </li>
          <li>
            <strong>Prawa osoby, której dane dotyczą:</strong> dostęp do danych, sprostowanie, usunięcie, ograniczenie przetwarzania, przenoszenie danych, cofnięcie zgody w dowolnym momencie, wniesienie skargi do Prezesa UODO.
          </li>
          <li>
            <strong>Dobrowolność podania danych:</strong> Podanie danych jest dobrowolne, ale niezbędne do udziału w obozie. Brak zgody uniemożliwi uczestnictwo.
          </li>
        </ol>
        
        {/* === Koniec treści – podmień na swoją === */}
      </div>
      <div className="px-6 py-4 border-t border-[#88cc00]/20 flex justify-end">
        <button
          className="px-5 py-2 rounded-lg bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold"
          onClick={() => setShowRodoModal(false)}
        >
          Zamknij
        </button>
      </div>
    </div>
  </div>
)}

{/* === MODAL: Polityka prywatności === */}
{showPrivacyModal && (
  <div className="fixed inset-0 z-[100] flex items-center justify-center">
    {/* tło */}
    <div
      className="absolute inset-0 bg-black/70"
      onClick={() => setShowPrivacyModal(false)}
    />
    {/* okno */}
    <div className="relative bg-[#0f1011] text-gray-100 w-[95vw] max-w-3xl max-h-[85vh] 
                    rounded-2xl border border-[#88cc00]/30 shadow-2xl overflow-hidden">
      {/* nagłówek */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-[#88cc00]/20">
        <h3 className="text-xl font-bold text-[#b9ff3c]">Polityka prywatności</h3>
        <button
          className="text-gray-300 hover:text-white text-2xl leading-none"
          onClick={() => setShowPrivacyModal(false)}
          aria-label="Zamknij"
        >
          ×
        </button>
      </div>

      {/* treść ze scrollem */}
      <div className="px-6 py-6 text-gray-200 text-sm leading-relaxed max-h-[65vh] overflow-y-auto space-y-6">
        <ol className="list-decimal pl-5 space-y-5">
          <li>
            <span className="font-semibold text-white">Administrator danych osobowych:</span>{" "}
            Stowarzyszenie Bonum Publicum, ul. 1 Maja 191, 25-646 Kielce. <br />
            Kontakt:{" "}
            <a
              href="mailto:rodo@przetrwajto.pl"
              className="underline text-yellow-300"
            >
              kontakt@przetrwajto.pl
            </a>
          </li>

          <li>
            <span className="font-semibold text-white">Zakres gromadzonych danych:</span>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Dane zgłaszającego (imię, nazwisko, wiek, e-mail, telefon)</li>
              <li>Dane uczestników (imię, nazwisko, wiek)</li>
              <li>Dane dodatkowe (liczba osób, preferencje, wizerunek – jeśli wyrażono zgodę)</li>
              <li>Dane techniczne (IP, cookies, przeglądarka)</li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-white">Cele i podstawy prawne:</span>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Rejestracja uczestnictwa – art. 6 ust. 1 lit. b RODO</li>
              <li>Bezpieczeństwo i opieka – art. 6 ust. 1 lit. c i d RODO</li>
              <li>Kontakt organizacyjny – art. 6 ust. 1 lit. f RODO</li>
              <li>Dokumentacja księgowa – art. 6 ust. 1 lit. c RODO</li>
              <li>Promocja (zdjęcia/wizerunek) – art. 6 ust. 1 lit. a RODO (zgoda)</li>
              <li>Marketing/statystyka strony – art. 6 ust. 1 lit. f RODO</li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-white">Czas przechowywania:</span>{" "}
            Dane przechowywane są do realizacji obozu, zgodnie z wymogami prawnymi
            (maks. 5 lat), a w przypadku zgody – do momentu jej cofnięcia.
          </li>

          <li>
            <span className="font-semibold text-white">Odbiorcy danych:</span>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Kadra i instruktorzy obozu</li>
              <li>Służby medyczne i ratownicze</li>
              <li>Ubezpieczyciele i podmioty IT/hostingowe</li>
              <li>Organy administracji – gdy wymagają tego przepisy</li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-white">Prawa uczestników:</span>{" "}
            dostęp, sprostowanie, usunięcie, ograniczenie, przenoszenie danych,
            sprzeciw, cofnięcie zgody, skarga do Prezesa UODO.
          </li>

          <li>
            <span className="font-semibold text-white">Cookies:</span> Strona używa plików cookies
            dla prawidłowego działania i analizy ruchu. Możesz je wyłączyć w przeglądarce.
          </li>

          <li>
            <span className="font-semibold text-white">Zabezpieczenie danych:</span>{" "}
            Dane chronione są technicznie i organizacyjnie (szyfrowanie, kontrola dostępu).
          </li>

          <li>
            <span className="font-semibold text-white">Dobrowolność podania danych:</span>{" "}
            Podanie danych jest dobrowolne, ale niezbędne do udziału w wydarzeniach.
          </li>

          <li>
            <span className="font-semibold text-white">Zmiany Polityki prywatności:</span>{" "}
            Dokument może być aktualizowany. Aktualna wersja publikowana jest na stronie.
          </li>
        </ol>
      </div>

      {/* stopka */}
      <div className="px-6 py-4 border-t border-[#88cc00]/20 flex justify-end">
        <button
          className="px-5 py-2 rounded-lg bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold"
          onClick={() => setShowPrivacyModal(false)}
        >
          Zamknij
        </button>
      </div>
    </div>
  </div>
)}



      {/* STOPKA */}
      <section id="kontakt"></section>
      <footer className="bg-black text-gray-400 py-12 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* LEWA */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">PrzetrwajTo</h3>
            <p>Profesjonalne obozy survivalowe dla dorosłych i rodzin.</p>
            <img
              src="/logo-wilk-wzgorze.png"
              alt="Logo PrzetrwajTo"
              className="h-40 mt-6 select-none"
            />
          </div>

          {/* MENU */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4">Menu</h4>
            <ul className="space-y-2">
              <li><a href="#top" className="hover:text-white transition">Strona główna</a></li>
              <li><a href="#oferta" className="hover:text-white transition">Oferta</a></li>
              <li><a href="#program" className="hover:text-white transition">Program</a></li>
              <li><a href="#terminarz" className="hover:text-white transition">Terminarz</a></li>
              <li><a href="#galeria" className="hover:text-white transition">Galeria</a></li>
              <li><a href="#formularz" className="hover:text-white transition">Zapisz się</a></li>
              <li><a href="#kontakt" className="hover:text-white transition">Kontakt</a></li>
            </ul>
          </div>

          {/* PRAWA */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4">Dane kontaktowe</h4>

            <p className="mb-2 flex items-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="#97e106" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M3 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H5v2a9 9 0 009 9h2v-2a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a11 11 0 01-11-11V7a2 2 0 012-2H5a2 2 0 01-2-2z" />
              </svg>
              <span className="animate-pulse" style={{ color: '#97e106', textShadow: '0 0 8px #97e106' }}>
                501 962 686
              </span>
            </p>

            <p className="mb-4 flex items-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="#97e106" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M16 12H8m8 0l-4 4m4-4l-4-4m8 4a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="animate-pulse" style={{ color: '#97e106', textShadow: '0 0 8px #97e106' }}>
                kontakt@przetrwajto.pl
              </span>
            </p>

            <p className="mb-4">Widełki 38, 26-021 Daleszyce </p>
            <p className="mb-4"> woj. świętokrzyskie</p>

            <div className="flex gap-4 mt-4">
              <a href="#" className="hover:text-white transition flex items-center gap-2">
                <svg className="w-5 h-5 fill-current" style={{ color: '#97e106' }} viewBox="0 0 24 24">
                  <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 
                    24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.894-4.788 
                    4.659-4.788 1.325 0 2.466.099 2.797.143v3.24l-1.919.001c-1.504 
                    0-1.796.715-1.796 1.763v2.31h3.587l-.467 3.622h-3.12V24h6.116C23.407 
                    24 24 23.407 24 22.676V1.325C24 .593 23.407 0 22.675 0z"/>
                </svg>
                Facebook
              </a>
              <a href="#" className="hover:text-white transition flex items-center gap-2">
                <svg className="w-5 h-5 fill-current" style={{ color: '#97e106' }} viewBox="0 0 24 24">
                  <path d="M23.498 6.186a2.998 2.998 0 00-2.112-2.12C19.694 3.5 
                    12 3.5 12 3.5s-7.694 0-9.386.566a2.998 2.998 0 00-2.112 
                    2.12A29.93 29.93 0 000 12a29.93 29.93 0 00.502 5.814 2.998 
                    2.998 0 002.112 2.12C4.306 20.5 12 20.5 12 20.5s7.694 0 
                    9.386-.566a2.998 2.998 0 002.112-2.12A29.93 29.93 0 0024 
                    12a29.93 29.93 0 00-.502-5.814zM9.75 15.02v-6.04L15.5 
                    12l-5.75 3.02z"/>
                </svg>
                YouTube
              </a>
            </div>
          </div>
        </div>

        <div className="text-center text-sm text-gray-500 mt-8">
          &copy; {new Date().getFullYear()} przetrwajto.pl – Wszelkie prawa zastrzeżone.
        </div>
      </footer>

      <ToastContainer position="bottom-center" autoClose={4000} hideProgressBar={false} />
    </div>
  );
}

export default App;
